const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;

const pluralize = (value: number, unit: string) =>
  `${value} ${unit}${value === 1 ? "" : "s"} ago`;

export const formatRelativeTime = (isoDate: string): string => {
  const diffMs = Math.max(0, Date.now() - new Date(isoDate).getTime());

  if (diffMs < MINUTE) return "Just now";
  if (diffMs < HOUR) return pluralize(Math.round(diffMs / MINUTE), "minute");
  if (diffMs < DAY) return pluralize(Math.round(diffMs / HOUR), "hour");
  if (diffMs < WEEK) return pluralize(Math.round(diffMs / DAY), "day");
  if (diffMs < MONTH) return pluralize(Math.round(diffMs / WEEK), "week");
  return pluralize(Math.round(diffMs / MONTH), "month");
};

export default formatRelativeTime;
